// import Logo from "../Logo/Logo";

import Links from "../../links/Links";
import Categories from "../categories/Categories";
import Logo from "../logo/Logo";
import SocialIcons from "../socialIcons/SocialIcons";
import "./footer.css";
import { Link } from "react-router-dom";

function Footer({ routes, iconData, brandName, mainBlogData }) {
  return (
    <footer className="footerContainer px-2">
      <div className="d-flex flex-column align-items-center flex-lg-row align-items-lg-start justify-content-between px-3">
        {/* Left side: Studio name */}
        <div className=" d-flex flex-column align-center gap-1 py-2  ">
          <div className="d-flex flex-column flex-md-row align-center gap-md-5">
            <Link to="/" className="navlogo">
              <Logo
                brandName={mainBlogData?.Logo?.url}
                location="footer"
                cl="logo-img-footer"
              />
            </Link>
            <p className="accent-1-color mt-3 fst-italic">
              {mainBlogData.logo_desc}
            </p>
          </div>
          {mainBlogData?.links && <SocialIcons links={mainBlogData?.links} />}
        </div>

        {/* Right side: Dynamic links or content */}
        <div className="d-flex flex-column gap-2 align-items-center align-items-lg-end">
          <Links cl="d-flex flex-row mt-3 flex-wrap" />
          <div>
            <Categories cl="d-flex flex-wrap w-sm-50 ps-0" />
          </div>

          {/* <div className="d-flex flex-column flex-sm-wrap gap-2 align-items-end "> */}
          {/* {routes?.map((link, i) => (
              <div
                key={link.href}
                className="d-flex flex-row flex-wrap gap-2 justify-content-center "
              >
                <Link to={"/" + link.href} className="footer-link base-color">
                  {link.label}
                </Link>
                {i === routes.length - 1 ? "" : "•"}
              </div>
            ))} */}
          {/* <Links cl="d-flex flex-row mt-3" />
            <Categories cl="flex-wrap w-sm-50 ps-0" />
          </div> */}
        </div>
      </div>
      <div className="d-flex flex-row justify-content-between px-3 flex-wrap">
        <p className="copy-text accent-3-color">
          &copy; {new Date().getFullYear()} Shift Theory. All rights reserved.
        </p>

        <div className=" d-flex flex-row gap-2 flex-wrap">
          <a href="https://iroirowebstudio.com">Site Credit </a>
          {/* <a href="https://elenadiaz.space">Privacy & Policy </a>
          <a href="https://elenadiaz.space">Terms & Condition </a> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
